import React from "react";
import QCTemplateBuilder from "./QCTemplateBuilder";

export default function QCTemplateEdit() {
  return <QCTemplateBuilder mode="edit" />;
}
